import React from 'react';

import svgIcon from 'components/hoc/svgIcon';

const svg = (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Atom / Icon / General / Edit_profile</title>
    <g id="Atom-/-Icon-/-General-/-Edit_profile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M15.9998,7 C19.8598,7 22.9998,10.589 22.9998,15 C22.9998,18.099 21.4168,20.911 18.9998,22.223 L18.9998,25 C18.9998,25.553 18.5518,26 17.9998,26 C17.4478,26 16.9998,25.553 16.9998,25 L16.9998,21.593 C16.9998,21.187 17.2438,20.823 17.6178,20.669 C19.6408,19.833 20.9998,17.555 20.9998,15 C20.9998,11.691 18.7568,9 15.9998,9 C13.2428,9 10.9998,11.691 10.9998,15 C10.9998,17.555 12.3588,19.833 14.3818,20.669 C14.7558,20.823 14.9998,21.187 14.9998,21.593 L14.9998,25 C14.9998,25.432 14.7228,25.814 14.3128,25.95 C14.2878,25.958 11.7578,26.796 9.4298,27.903 C8.0178,28.574 7.4218,30.01 7.1728,31 L25.9998,31 C26.5518,31 26.9998,31.447 26.9998,32 C26.9998,32.553 26.5518,33 25.9998,33 L5.9998,33 C5.7278,33 5.4678,32.889 5.2788,32.693 C5.0898,32.497 4.9898,32.232 5.0008,31.96 C5.0078,31.787 5.2078,27.696 8.5698,26.097 C10.2848,25.282 12.0558,24.621 12.9998,24.287 L12.9998,22.223 C10.5828,20.911 8.9998,18.098 8.9998,15 C8.9998,10.589 12.1398,7 15.9998,7 Z M34.0451,15.9539 C35.6591,17.5679 34.9311,19.4769 34.0481,20.3659 L27.7071,26.7069 C25.5626405,28.8513595 22.4929437,28.9905413 22.0496944,28.9993223 L22.0001,28.9999 L22.0001,28.9999 C21.4471,28.9999 21.0001,28.5529 21.0001,27.9999 L21.0006777,27.9501605 C21.0094587,27.5061615 21.1486405,24.4373595 23.2931,22.2929 L29.6311,15.9539 C30.5341,15.0709 32.4461,14.3549 34.0451,15.9539 Z M31.8611,17.0029 C31.5111,17.0029 31.2151,17.2109 31.0281,17.3849 L24.7071,23.7069 C23.7311,24.6829 23.3131,25.9559 23.1341,26.8619 C24.0451,26.6809 25.3241,26.2609 26.2931,25.2929 L32.6311,18.9539 C32.9131,18.6559 33.3021,18.0399 32.6311,17.3679 C32.3611,17.0989 32.0991,17.0029 31.8611,17.0029 Z"
        id="Combined-Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

export default svgIcon(svg);
